<ng-container *transloco="let t; prefix: 'transaction_details'">
  <!-- Transaction Details modal -->
  <qwiko-modal
    [id]="'transaction-details-modal'"
    [isCentered]="true"
    [isFullScreen]="true"
    [isDismissible]="true"
    (closeEvent)="closeModal()"
  >
    @if (isTransactionDetails()) {
      <div
        class="top-0 right-0 left-0 z-50 pt-2 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="flex md:hidden justify-start items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="closeModal('transaction-details-modal')"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">
                {{ t("back") }}
              </span>
            </span>
          </button>
        </div>
        <div class="hidden md:flex justify-end items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="closeModal('transaction-details-modal')"
          >
            <span class="flex items-center gap-1">
              <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
                t("close")
              }}</span>
              <i class="fa-light text-base fa-xmark"></i>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <img
            *ngIf="
              $any($any(transaction()?.receiver_account)?.payment_provider)
                ?.icon || $any(paymentAccount()?.payment_provider)?.icon
            "
            class="rounded-full size-16 md:w-20 md:h-20 mx-auto mb-4"
            src="/assets/icons/providers/{{
              $any($any(transaction()?.receiver_account)?.payment_provider)
                ?.icon || $any(paymentAccount()?.payment_provider)?.icon
            }}"
            alt=""
          />
          <h2 class="text-2xl font-normal text-center w-full">
            {{ t("modal_title") }}
          </h2>
          @if (
            !(transaction()?.status == transactionStatus.CANCELED) &&
            !(transaction()?.status == transactionStatus.CONFIRMED)
          ) {
            <p class="text-center w-full mb-2">
              {{ t("modal_caption") }}
            </p>
          }
          <!-- <h2 class="text-xl font-normal text-center w-full mb-2">
        {{ selectedProvider()?.display_name }}
        Name here
      </h2> -->
        </div>
      </div>
      <div class="w-full px-4 mx-auto my-5">
        <!-- <div class="flex items-center justify-between gap-x-2 mt-2">
        <span class="text-xs uppercase">{{ t("transaction_id") }}:</span>
        <span class="font-semibold">{{ transaction()?.id }}</span>
      </div> -->
        <div class="flex items-center justify-between gap-x-2 mt-2">
          <span class="text-xs uppercase">{{ t("amount") }}:</span>
          <span class="font-semibold">
            {{ transaction()?.amount | number: "1.0-2" }}
            {{ $any(transaction()?.country)?.currency }}
          </span>
        </div>
        <div class="flex items-center justify-between gap-x-2 mt-2">
          <span class="text-xs uppercase">{{ t("status") }}:</span>

          <div
            (click)="changeStatus()"
            class="flex gap-2 badge badge-md text-white font-semibold uppercase hover:md:opacity-90 cursor-pointer"
            [ngClass]="{
              'bg-slate-500': status() == transactionStatus.INITIATED,
              'badge-warning': status() == transactionStatus.PENDING,
              'badge-success': status() == transactionStatus.CONFIRMED,
              'bg-slate-400 dark:bg-slate-800':
                status() == transactionStatus.CANCELED,
            }"
            *transloco="let t; prefix: 'transaction_status'"
          >
            <span class="mt-1">{{ t(status() ?? "null") }}</span>
            <i
              *ngIf="
                ((status() === transactionStatus.PENDING &&
                  transaction()?.status === transactionStatus.PENDING) ||
                  (status() === transactionStatus.INITIATED &&
                    transaction()?.status === transactionStatus.INITIATED) ||
                  status() !== transaction()?.status) &&
                !this.hasConfirmed()
              "
              class="fa-solid fa-pen-to-square text-sm py-1"
            ></i>
          </div>
        </div>
        <div class="flex items-center justify-between gap-x-2 mt-2">
          <span class="text-xs uppercase">{{ t("created_at") }}:</span>
          <span class="font-semibold first-letter:uppercase">
            {{ transaction()?.date_created! | readableTime }}
          </span>
        </div>
        <div
          *ngIf="
            transaction()?.customer_number || transaction()?.sender_account
          "
          class="flex items-center justify-between gap-x-2 mt-2"
        >
          <span class="text-xs uppercase">{{ t("sender") }}:</span>
          <span class="font-semibold">
            @if (transaction()?.customer_number) {
              {{ transaction()?.customer_number }}
            } @else {
              @if (transaction()?.sender_account) {
                @if ($any(transaction()?.sender_account)?.label) {
                  {{ $any(transaction()?.sender_account)?.label }}
                } @else {
                  {{
                    $any($any(transaction()?.sender_account)?.payment_provider)
                      ?.name
                  }}
                  ({{ $any(transaction()?.sender_account)?.number_display }})
                }
              } @else {
                <span class="text-warning"> {{ t("no_sender") }}</span>
              }
            }
          </span>
        </div>
        <div class="flex items-center justify-between gap-x-2 mt-2">
          <span class="text-xs uppercase">{{ t("account") }}:</span>
          <span class="font-semibold">
            @if (!!transaction()?.receiver_account) {
              @if ($any(transaction()?.receiver_account)?.label) {
                {{ $any(transaction()?.receiver_account)?.label }}
              } @else {
                {{
                  $any($any(transaction()?.receiver_account)?.payment_provider)
                    ?.name
                }}
                ({{ $any(transaction()?.receiver_account)?.number_display }})
              }
            } @else if (!!paymentAccount()) {
              <button
                (click)="addAccount()"
                class="btn btn-outline btn-sm rounded-box btn-ghost"
              >
                <div class="flex gap-2">
                  <span class="mt-2">
                    @if (paymentAccount()?.label) {
                      {{ paymentAccount()?.label }}
                    } @else {
                      {{ $any(paymentAccount()?.payment_provider)?.name }}
                      ({{ paymentAccount()?.number_display }})
                    }
                  </span>
                  <i
                    class="fa-light fa-pen-to-square text-neutral-500 text-lg mr-1"
                  ></i>
                </div>
              </button>
            } @else {
              @if (
                this.transaction()?.status == transactionStatus.CANCELED ||
                this.transaction()?.status == transactionStatus.CONFIRMED
              ) {
                <span class="text-slate-500">{{ t("no_account") }}</span>
              } @else {
                <button
                  (click)="addAccount()"
                  class="btn btn-outline btn-xs rounded-box btn-ghost"
                >
                  <div class="flex gap-1">
                    <i class="fa-light fa-circle-plus text-base"></i>
                    <span class="mt-[0.4rem]">{{ t("add_account") }}</span>
                  </div>
                </button>
              }
            }
          </span>
        </div>
      </div>

      <div
        class="fixed md:relative bottom-0 right-0 left-0 mt-5 md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        @if (
          !!(
            !!(transaction()?.receiver_account || paymentAccount()) &&
            !(
              status() == transactionStatus.CANCELED ||
              transaction()?.status == transactionStatus.CONFIRMED ||
              (status() === transactionStatus.PENDING &&
                transaction()?.status === transactionStatus.INITIATED)
            ) &&
            !this.hasConfirmed()
          )
        ) {
          <button
            type="button"
            class="btn btn-md w-full md:w-8/12 mx-auto btn-success rounded-box"
            [disabled]="loading()"
            (click)="confirmTransaction()"
          >
            @if (loading()) {
              <span class="loading loading-spinner"></span>
            } @else {
              <div class="flex w-100 gap-2 justify-center items-center">
                <i class="fa-solid fa-circle-check text-white text-xl"></i>
                <span class="text-white">
                  {{ t("confirm_transaction") }}
                </span>
              </div>
            }
          </button>
        }

        @if (
          status() == transactionStatus.CANCELED &&
          !this.hasConfirmed() &&
          transaction()?.status !== transactionStatus.CANCELED
        ) {
          <button
            type="button"
            class="btn btn-md w-full md:w-8/12 mx-auto bg-slate-500 hover:bg-slate-500 md:hover:bg-slate-400 rounded-box"
            [disabled]="loading()"
            (click)="confirmTransaction()"
          >
            @if (loading()) {
              <span class="loading loading-spinner"></span>
            } @else {
              <div class="flex w-100 gap-2 justify-center items-center">
                <i class="fa-solid fa-circle-xmark text-white text-xl"></i>
                <span class="text-white">
                  {{ t("cancel_transaction") }}
                </span>
              </div>
            }
          </button>
        }
        @if (
          transaction()?.status !== transactionStatus.PENDING &&
          status() == transactionStatus.PENDING &&
          !this.hasConfirmed()
        ) {
          <button
            type="button"
            class="btn btn-md w-full md:w-8/12 mx-auto bg-slate-500 hover:bg-slate-500 md:hover:bg-slate-400 rounded-box"
            [disabled]="loading()"
            (click)="confirmTransaction()"
          >
            @if (loading()) {
              <span class="loading loading-spinner"></span>
            } @else {
              <div class="flex w-100 gap-2 justify-center items-center">
                <i class="fa-solid fa-save text-white text-xl"></i>
                <span class="text-white">
                  {{ t("update_transaction") }}
                </span>
              </div>
            }
          </button>
        }
        <button
          type="button"
          class="btn btn-md btn-outline w-full md:w-8/12 mx-auto rounded-box"
          (click)="closeModal('transaction-details-modal')"
          [disabled]="loading()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span *transloco="let t"> {{ t("close") }} </span>
          }
        </button>
      </div>
    }

    @if (isChoosePaymentAccount()) {
      <div
        class="top-0 right-0 left-0 z-50 pt-2 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="flex justify-start items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <h2 class="text-2xl font-normal text-left md:text-center w-full mb-2">
            {{ t("payment_accounts_title") }}
          </h2>
          <p class="text-left md:text-center w-full mb-2">
            {{ t("payment_accounts_caption") }}
          </p>
        </div>
      </div>

      <div
        class="w-full md:w-9/12 mx-auto pb-10 md:pb-24 max-h-[75vh] md:max-h-[55vh] px-6 md:px-5 pt-2 overflow-y-auto"
      >
        @for (
          account of businessPaymentAccounts();
          track $index;
          let count = $count
        ) {
          <button
            type="button"
            [disabled]="loading()"
            (click)="addAccount(account)"
            class="btn flex flex-row justify-between items-center p-3 w-full text-md border-neutral-200 mt-2 rounded-box border shadow text-md text-base-content font-normal bg-base-200 h-full hover:bg-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:bg-primary dark:hover:text-white"
          >
            <div class="flex flex-row gap-3 justify-center items-center">
              <div class="rounded-full size-11 bg-neutral-400">
                <img
                  src="/assets/icons/providers/{{
                    account.payment_provider?.icon
                  }}"
                  class=""
                  alt=""
                />
              </div>
              <div class="flex flex-col items-start">
                <span class="text-base">{{
                  account.label ? account.label : account.name
                }}</span>
                <span class="text-neutral-400 mt-1">{{
                  account.number_display
                }}</span>
              </div>
            </div>
            <i class="fa-light fa-add text-neutral-500 text-xl mr-1"></i>
          </button>
        } @empty {
          @if (loading()) {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
            >
              <span class="loading loading-spinner w-9"></span>
            </div>
          } @else {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
            >
              <i class="fa-light fa-xmark-to-slot text-lg"></i>
              <p class="text-md mt-1">{{ t("no_payment_accounts") }}</p>
            </div>
          }
        }
      </div>
      <!-- <div
        class="fixed bottom-0 right-0 left-0 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          type="button"
          class="btn btn-md w-full md:w-9/12 mx-auto rounded-box"
          ngClass="{{
            businessPaymentAccounts().length
              ? 'btn-outline btn-ghost'
              : 'btn-primary'
          }}
          "
          (click)="addPaymentAccount()"
        >
          <span class="flex items-center gap-3">
            <i class="fa-light fa-circle-plus text-2xl"></i>
            <span class="text-base mt-1">{{ t("add_payment_method") }}</span>
          </span>
        </button>
      </div> -->
    }

    @if (isChooseStatus()) {
      <div
        class="top-0 right-0 left-0 z-50 pt-2 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="flex justify-start items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <h2 class="text-2xl font-normal text-left md:text-center w-full mb-2">
            {{ t("choose_status_title") }}
          </h2>
          <p class="text-left md:text-center w-full mb-2">
            {{ t("choose_status_caption") }}
          </p>
        </div>
      </div>

      <div
        class="w-full md:w-9/12 mx-auto pb-10 md:pb-24 max-h-[75vh] md:max-h-[55vh] px-6 md:px-5 pt-2 overflow-y-auto"
      >
        <div
          class="grid grid-cols-1 gap-4 md:gap-2 my-4"
          *transloco="let t; prefix: 'transaction_status'"
        >
          <!-- <div
            (click)="changeStatus(transactionStatus.INITIATED)"
            class="group cursor-pointer hover:md:opacity-90 hover:md:bg-slate-500 transition-all duration-100 stats shadow bg-neutral-100 dark:bg-base-100 rounded-box"
          >
            <div class="stat p-4">
              <div
                class="stat-figure group-hover:md:!text-white dark:text-slate-300 text-primary hidden md:flex"
              >
                <i
                  class="fa-solid fa-circle-check group-hover:md:!text-white text-slate-500 text-4xl"
                ></i>
              </div>
              <div
                class="stat-value text-4xl group-hover:md:!text-white text-slate-500 leading-none"
              >
                {{ t(transactionStatus.INITIATED) }}
              </div>
            </div>
          </div> -->

          <div
            (click)="changeStatus(transactionStatus.PENDING)"
            class="group cursor-pointer hover:md:opacity-90 hover:md:bg-warning transition-all duration-100 stats shadow bg-neutral-100 dark:bg-base-100 rounded-box"
          >
            <div class="stat p-4">
              <div
                class="stat-figure group-hover:md:!text-white dark:text-slate-300 text-primary hidden md:flex"
              >
                <i
                  class="fa-solid fa-hourglass-clock group-hover:md:!text-white text-warning text-3xl"
                ></i>
              </div>
              <div
                class="stat-value text-4xl group-hover:md:!text-white text-warning leading-none"
              >
                {{ t(transactionStatus.PENDING) }}
              </div>
              <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                    +1.3M this Month
                  </div> -->
            </div>
          </div>

          <div
            (click)="changeStatus(transactionStatus.CONFIRMED)"
            class="group cursor-pointer hover:md:opacity-90 hover:md:bg-success transition-all duration-100 stats shadow bg-neutral-100 dark:bg-base-100 rounded-box"
          >
            <div class="stat p-4">
              <div
                class="stat-figure group-hover:md:!text-white dark:text-slate-300 text-primary hidden md:flex"
              >
                <i
                  class="fa-solid fa-circle-check group-hover:md:!text-white text-success text-4xl"
                ></i>
              </div>
              <div
                class="stat-value text-4xl group-hover:md:!text-white text-success leading-none"
              >
                {{ t(transactionStatus.CONFIRMED) }}
              </div>
              <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                    +1.3M this Month
                  </div> -->
            </div>
          </div>
          <div
            (click)="changeStatus(transactionStatus.CANCELED)"
            class="group cursor-pointer hover:md:opacity-90 hover:md:bg-slate-400 transition-all duration-100 stats shadow bg-neutral-100 dark:bg-base-100 rounded-box"
          >
            <div class="stat p-4">
              <div
                class="stat-figure group-hover:md:!text-white dark:text-slate-300 text-primary hidden md:flex"
              >
                <i
                  class="fa-solid fa-circle-xmark group-hover:md:!text-white text-slate-400 dark:text-slate-600 text-4xl"
                ></i>
              </div>
              <div
                class="stat-value text-4xl group-hover:md:!text-white text-slate-400 dark:text-slate-600 leading-none"
              >
                {{ t(transactionStatus.CANCELED) }}
              </div>
              <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                    +1.3M this Month
                  </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div
        class="fixed bottom-0 right-0 left-0 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          type="button"
          class="btn btn-md w-full md:w-9/12 mx-auto rounded-box"
          ngClass="{{
            businessPaymentAccounts().length
              ? 'btn-outline btn-ghost'
              : 'btn-primary'
          }}
          "
          (click)="addPaymentAccount()"
        >
          <span class="flex items-center gap-3">
            <i class="fa-light fa-circle-plus text-2xl"></i>
            <span class="text-base mt-1">{{ t("add_payment_method") }}</span>
          </span>
        </button>
      </div> -->
    }
  </qwiko-modal>
</ng-container>
